import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-filter-modal",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./filter-modal.component.html",
  styleUrl: "./filter-modal.component.scss",
})
export class FilterModalComponent {
  @Input()
  configs: any = {};

  executionCycles: any[] = [];

  selectedExecutionCycle: string = "";
  selectedTestPlan: string = "";
  selectedStatuses: string[] = [];
  availableTestPlans: any[] = [];

  statusCards: { label: string; value: string; icon: string }[] = [
    { label: 'Passed',      value: 'pass',      icon: 'assets/images/virtusa-icons/passed-status.svg' },
    { label: 'Executing',     value: 'executing',     icon: 'assets/images/virtusa-icons/executing-status.svg' },
    { label: 'Waiting', value: 'waiting', icon: 'assets/images/virtusa-icons/waiting-status.svg' },
    { label: 'Pending',     value: 'pending',     icon: 'assets/images/virtusa-icons/waiting-status.svg' },
    { label: 'Failed',      value: 'fail',      icon: 'assets/images/virtusa-icons/failed-status.svg' },
    { label: 'Exited',       value: 'exited',       icon: 'assets/images/virtusa-icons/failed-status.svg' },
    { label: 'Skipped',     value: 'skipped',     icon: 'assets/images/virtusa-icons/failed-status.svg' },
    { label: 'Aborted',  value: 'aborted',  icon: 'assets/images/virtusa-icons/failed-status.svg' },
  ];

  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;

  ngOnInit() {
    if (this.configs?.executionCycles?.length) {
      this.executionCycles = this.configs.executionCycles;
    }

    const prev = this.configs?.previousFilter;
    if (prev) {
      this.selectedExecutionCycle = prev.executionCycle ?? "";
      this.selectedStatuses = prev.statuses ? [...prev.statuses] : [];
      if (this.selectedExecutionCycle) {
        const cycle = this.executionCycles.find((c: any) => c.id === this.selectedExecutionCycle);
        this.availableTestPlans = cycle?.children ?? [];
      }
      this.selectedTestPlan = prev.testPlan ?? "";
    }
  }

  resetAll(): void {
    this.selectedExecutionCycle = "";
    this.selectedTestPlan = "";
    this.selectedStatuses = [];
    this.availableTestPlans = [];
    // this.activeModal.dismiss('reset');
  }
  onCycleChange(cycleId: string): void {
    this.selectedTestPlan = "";
    const cycle = this.executionCycles.find((c: any) => c.id === cycleId);
    this.availableTestPlans = cycle?.children ?? [];
  }

  toggleStatus(value: string): void {
    const index = this.selectedStatuses.indexOf(value);
    if (index === -1) {
      this.selectedStatuses.push(value);
    } else {
      this.selectedStatuses.splice(index, 1);
    }
  }

  isStatusSelected(value: string): boolean {
    return this.selectedStatuses.includes(value);
  }

  getStatusIcon(card: { icon: string; value: string }): string {
    return this.isStatusSelected(card.value)
      ? card.icon.replace('.svg', '-dark.svg')
      : card.icon;
  }

  submit() {
    this.activeModal.close({
      executionCycle: this.selectedExecutionCycle,
      testPlan: this.selectedTestPlan,
      statuses: this.selectedStatuses,
    });
  }
}
